import { PopoverTrigger, Portal, PopoverContent, PopoverBody, Popover } from "@chakra-ui/react"
import { ReactNode } from "react"

type PopoverProps = { 
    trigger: ReactNode;
    children: ReactNode;
    onClose?: () => void;
    width?: number;
};

const PopoverWrapper = ({trigger, children, onClose, width}: PopoverProps) => {
    return (
      <Popover onClose={onClose} placement='bottom' >
        {() => (
          <>
            <PopoverTrigger>
            {trigger}
            </PopoverTrigger>
            <Portal>
              <PopoverContent borderRadius="45px" width={width ? width : 'max-content'}>
                <PopoverBody>
                  {children}
                </PopoverBody>
              </PopoverContent>
            </Portal>
          </>
        )}
      </Popover>
    )
};

export { PopoverWrapper as Popover };
